import { Controller } from '../utils/controller';

export default class extends Controller {
  static values = {
    link: String,
    isAbsolute: Number,
    isFragment: Number
  };

  // VALUES
  declare linkValue: string;
  declare isAbsoluteValue: number;
  declare isFragmentValue: number;

  // LOCAL STATE
  private isAbsolute: number;
  private isFragment: number;

  initialize() {
    this.isAbsolute = 1;
    this.isFragment = 1;
  }

  redirect() {
    if (this.isAbsoluteValue === this.isAbsolute) {
      window.open(this.linkValue, '_blank', 'noreferrer');
      return;
    }

    if (this.isFragmentValue === this.isFragment) {
      window.scrollTo(0, document.getElementById(this.linkValue)?.offsetTop || 0);
      return;
    }

    window.location.href = this.linkValue;
  }

  connect() {
    this._jumpOverToFragmentIfHashExists();
  }

  _jumpOverToFragmentIfHashExists() {
    if (!window.location.hash) {
      return;
    }

    const targetAnchor = this.element.querySelector(`a${location.hash}`);
    const offsetTop = targetAnchor != null && (targetAnchor as HTMLElement).offsetTop;
    if (offsetTop) {
      window.scrollTo({ top: offsetTop });
    }
  }

  handleKeyUp(event) {
    if (event.key === 'Enter') {
      this.redirect();
    }
  }
}
